import { api } from '@/lib/axios';
import { type PdfMode, renderPdf } from '@/lib/pdf';
import type { Page } from '@/services/chantiers';

export type SituationStatut = 'BROUILLON' | 'SOUMIS' | 'VALIDE' | 'REJETE' | 'PAYE';

export interface LigneSituationInput {
  designation: string;
  unite?: string | null;
  quantite_marche?: number;
  quantite_periode: number;
  prix_unitaire: number;
}

export interface SituationDTO {
  id: string;
  numero: number;
  chantier_id: string;
  mois: number;
  annee: number;
  date_etablissement: string | null;
  montant_travaux_brut: number;
  montant_travaux_revise: number;
  net_a_payer: number;
  statut: SituationStatut;
  is_archived: boolean;
}

export interface SituationInput {
  chantier_id: string;
  numero: number;
  mois: number;
  annee: number;
  taux_revision: number;
  retenue_garantie_pct: number;
  avance_a_rembourser: number;
  lignes: LigneSituationInput[];
}

export async function listSituations(params?: { chantier_id?: string; statut?: SituationStatut; archives?: boolean }): Promise<Page<SituationDTO>> {
  const { data } = await api.get<Page<SituationDTO>>('/situations', { params });
  return data;
}

export async function updateSituation(id: string, payload: { is_archived?: boolean; statut?: SituationStatut }): Promise<SituationDTO> {
  const { data } = await api.put<SituationDTO>(`/situations/${id}`, payload);
  return data;
}

export async function deleteSituation(id: string): Promise<void> {
  await api.delete(`/situations/${id}`);
}

export async function createSituation(payload: SituationInput): Promise<SituationDTO> {
  const { data } = await api.post<SituationDTO>('/situations', payload);
  return data;
}

/** Génération assistée : crée/met à jour (idempotent) le brouillon de facture Production lié. */
export async function genererFactureDepuisSituation(id: string): Promise<import('@/services/ventes').FactureVenteDTO> {
  const { data } = await api.post(`/situations/${id}/generer-facture`);
  return data as import('@/services/ventes').FactureVenteDTO;
}

export async function changerStatutSituation(id: string, statut: SituationStatut): Promise<SituationDTO> {
  const { data } = await api.post<SituationDTO>(`/situations/${id}/statut`, null, { params: { statut } });
  return data;
}

/** Ouvre/télécharge le PDF de la situation (avec jeton JWT). */
export async function openSituationPdf(id: string, mode: PdfMode = 'open'): Promise<void> {
  await renderPdf(`/situations/${id}/pdf`, undefined, mode);
}
